import { observer } from 'mobx-react-lite';
import { HospitalQueueRowData } from '../../../socket/stream-types';
import useDimensions from 'react-cool-dimensions';
import { useContextMenuStateWrite } from '../../../queues/context/use-context-menu-state';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { UnitsDisplay } from '../../../common/components/units-display';

export const HospitalQueueUnitsCell = observer(function HospitalQueueUnitsCell({
    data,
}: {
    data: HospitalQueueRowData;
}): React.ReactElement {
    const { observe, width } = useDimensions();
    const contextMenuStateWrite = useContextMenuStateWrite();

    return (
        <BaseQueueCell ref={observe}>
            <UnitsDisplay
                width={width}
                units={data.pillUnits ?? []}
                enableContextMenu={true}
                contextMenuStateWrite={contextMenuStateWrite}
            />
        </BaseQueueCell>
    );
});
